<template>
  <base-dialog
    @on-close="closeDialog"
    @on-sure="sureDialog"
    :title="title"
    :width="width"
    :append-to-body="true"
  >
    <div class="brand-select">
      <div class="brand-list">
        <el-row :gutter="12">
          <el-col :key="index" :span="12" v-for="(info, index) in allBrandList" class="mb_20">
            <div @click="selectedBrandIndex = index">
              <el-card
                shadow="hover"
                :class="[
                  index === selectedBrandIndex ? 'activity-wrapper' : ''
                ]"
              >
                <div class="brand-wrapper">
                  <img :src="info.brandLogo" class="brand-logo" alt />
                  <div class="brand-detail">
                    <div class="name-wrapper">{{ info.name }}</div>
                    <div class="industry-wrapper break-word" :title="info.categoryName">
                      <span>行业信息：</span>
                      <span>{{ info.categoryName }}</span>
                    </div>
                  </div>
                </div>
                <i class="icon iconfont icondangqian" v-show="info.id === brandId"></i>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </base-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import baseDialogMixin from '@/mixins/baseDialogMixin'
import { IMG_SERVE_URL } from '@/config'
import { isEmpty } from '../../utils'
// import { RES_OK } from '../../config'
// import { isEmpty } from '../../utils'
// const logoPic = require('../../assets/images/hy-logo.png')
export default {
  props: {
    brandId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      title: '选择品牌',
      width: 650,
      selectedBrandIndex: -1,
      allBrandList: []
    }
  },
  mixins: [baseDialogMixin],
  computed: {
    ...mapGetters(['brandList', 'companyId'])
  },
  mounted() {
    this.allBrandList = [].concat(this.brandList)
    this.allBrandList.forEach(info => {
      if (isEmpty(info.logoUrl)) {
        // return require('../../../assets/images/cx-logo.png')
        // info.brandLogo = require('../../assets/images/cx-logo.png')
        let host = location.host
        if (host === 'wk.zwot.cn') {
          info.brandLogo = require('../../assets/images/cx-logo.png')
        } else if (host === 'wk.hyunst.com') {
          info.brandLogo = require('../../assets/images/hy-logo.png')
        } else if (host === 'sh.zwot.cn') {
          info.brandLogo = require('../../assets/images/ttd-logo.png')
        } else if (host === 'syxf.hyunst.com') {
          info.brandLogo = require('../../assets/images/syxf-logo.png')
        } else {
          info.brandLogo = require('../../assets/images/hy-logo.png')
        }
      } else {
        info.brandLogo = IMG_SERVE_URL + info.logoUrl
      }
      let categoryNameList = []
      info.categoryInfo.forEach(item => {
        categoryNameList.push(item.categoryName)
      })
      info.categoryName = categoryNameList.join('、')
    })
  },
  methods: {
    ...mapActions(['']),
    sureDialog() {
      let brandObj = this.allBrandList[this.selectedBrandIndex]
      if (brandObj.curState === '5') {
        this.$message({
          type: 'warning',
          message: '该品牌已冻结，暂时不能操作'
        })
        return
      }
      let id = brandObj.id
      this.$emit('sure', id)
    },
    closeDialog() {
      this.$emit('on-close')
    }
  }
}
</script>
<style lang="scss">
@import '../../assets/scss/variable.scss';
.el-dialog {
  .el-dialog__body {
    .brand-select {
      .brand-list {
        padding: 20px;
        font-size: 12px;
        max-height: 500px;
        overflow: auto;
        .activity-wrapper {
          border: solid 1px $colorPrimary;
        }
        .el-card {
          border-radius: 10px;
          position: relative;
          .brand-wrapper {
            height: 40px;
            display: flex;
            align-items: center;
            .brand-logo {
              width: 44px;
              height: 32px;
              padding: 3px;
              border: solid 1px $colorGray1;
            }
            .brand-detail {
              margin-left: 20px;
              display: flex;
              flex-direction: column;
              .name-wrapper {
                font-size: 14px;
                font-weight: bold;
                color: $colorBlack2;
              }
              .industry-wrapper {
                .name-tips {
                  min-width: 60px;
                }
                max-width: 200px;
                margin-top: 10px;
                // display: flex;
                // align-items: center;
                color: $colorDefault;
                font-size: 12px;
              }
            }
          }
        }
        .icondangqian {
          position: absolute;
          right: 0px;
          top: -3px;
          font-size: 40px;
          color: $colorPrimary;
        }
      }
    }
  }
}
</style>
